import { defineStore } from 'pinia'
import {useToggle} from "@/utils/use-toggle";

export const useOverlayStore = defineStore('overlayStore',  () => {
    const {
        isActive: isShowModalSearch,
        closeHandler: closeModalSearch,
        openHandler: openModalSearch
    } = useToggle()

    return {
        isShowModalSearch,
        closeModalSearch,
        openModalSearch
    }
})